export const CAMPAIGN_SESSION_KEY = 'campaignBannerSession';

export const RUSSIA_FUND_HASH = '690610BCD1829F9E0C2026778C3F1C73EF766FED';

export const FUND_DOCUMENTS_HEADER_TYPES_MATCHING = {
  'Basisinformationsblatt - Lang- und Kurzbezeichnung': 'BIB',
  'Kundeninformationsdokument (KID)': 'KID',
  Halbjahresberichte: 'HJB',
  Rechenschaftsberichte: 'RB',
  'ESG (Kurzbezeichnung)': 'ESG',
  'ESGH (Kurzbezeichnung)': 'ESGhist',
  'Verkaufsprospekt (inkl. Fondsbestimmungen)': 'PROS',
  'Historisch laufende Kosten': 'HLK',
  Produktblatt: 'PB',
  'Gesetze u. Steuern': 'STEUER',
  '§ 21 AIFMG Informationsdokument (inkl. Fondsbestimmungen)': 'AI',
  'Nachhaltigkeitsbezogene Offenlegung - Anhang Rechenschaftsbericht': 'PDFP',
  'Nachhaltigkeitsbezogene Offenlegung - Anhang Prospekt': 'PCDFP',
};

export const FF_QUESTIONNAIRE_MODAL_OPEN_EVENT = 'ohFFQuestionnaireOpen';
export const FUNDS_HEADER_VARIANT = 'variant';

export const RETAIL_CONSENT_EVENT = 'rcmUserConsentModalOpenRetail';
export const INSTITUTIONAL_CONSENT_EVENT = 'rcmUserConsentModalOpenInstitutional';
